import SafaricomService from '../services/SafaricomService';
import MTNService from '../services/MTNService';

export default function makePurchaseService(vendor, token) {
    switch (vendor) {
    case 'mtn':
        return new MTNService(token)

    case 'safaricom':
        return new SafaricomService(token)

    default:
        throw new Error('Unsupported vendor')
    }
}
